<template>
  <v-data-table
    :items="dataHosts"
    :headers="headers"
    item-key="id"
    :items-per-page="1000"
    hide-default-footer
    :loading="loading"
    :search="search"
  >
    <template #top>
      <v-container class="pb-0" fluid>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col v-if="!loading" cols="12" sm="6" lg="4">
            <v-text-field
              v-model="search"
              :label="$t('label.input.search')"
              clearable
              prepend-inner-icon="mdi-magnify"
            >
              <template v-if="$slots.append" #append-outer>
                <slot name="append" />
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template #item.name="{ item }">
      <router-link
        :to="{
          name: 'Usage data host detail',
          params: { dataHostId: item.id },
        }"
        >{{ item.name }}
      </router-link>
    </template>
    <template #item.lastAudit.finish_date="{ item }">
      <IsoDate :date="item.lastAudit.finish_date" v-if="item.lastAudit" />
    </template>
    <template #item.upcomingAudit.start_date="{ item }">
      <IsoDate
        :date="item.upcomingAudit.start_date"
        v-if="item.upcomingAudit"
      />
    </template>
    <template #item.audit_status="{ item }">
      <AuditStatus :status="item.audit_status" />
    </template>
  </v-data-table>
</template>

<script>
import IsoDate from "./IsoDate";
import AuditStatus from "./AuditStatus";

export default {
  name: "UsageDataHostList",
  components: { AuditStatus, IsoDate },
  props: {
    dataHosts: { type: Array, required: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      search: "",
    };
  },

  computed: {
    headers() {
      let ret = [
        { text: this.$t("label.dataHost.abbrev"), value: "abbrev" },
        { text: this.$t("label.dataHost.name"), value: "name" },
        {
          text: this.$t("label.dataHost.platformCount"),
          value: "platformCount",
          align: "right",
        },
        {
          text: this.$t("label.info.lastAudit"),
          value: "lastAudit.finish_date",
          align: "right",
        },
        {
          text: this.$t("label.info.upcomingAudit"),
          value: "upcomingAudit.start_date",
          align: "right",
        },
        {
          text: this.$t("label.info.auditStatus"),
          value: "audit_status",
        },
      ];
      return ret;
    },
  },
};
</script>

<style scoped></style>
